import { startPositionSyncTask } from "@/service/appList.js";
export default {
  name: "AppDetailPositionSync",
  data() {
    return {
      syncLoading: false
    };
  },
  methods: {
    /*
     * 二次确认后再发起岗位同步任务，避免误操作和重复触发后端任务。
     */
    confirmSync() {
      this.$Modal.confirm({
        title: $t("hn562", "提示"),
        content: $t("41x8ah14", "确认从钉钉同步最新的岗位及人员分配数据到 iWork 吗？此操作可能需要几分钟。"),
        onOk: async () => {
          this.syncLoading = true;
          try {
            const res = await startPositionSyncTask({
              upstream: "DING_TALK"
            });
            if (res.data && res.data.result === 0) {
              this.$Message.success($t("b1twyw4", "同步成功"));
            }
            // 失败提示由全局 axios 拦截器统一展示，避免同一后端消息重复弹出。
          } finally {
            this.syncLoading = false;
          }
        }
      });
    }
  }
};